import { useEffect, useState } from "react";
import {
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

const useServerPaginatedDataTableFilter = ({
  onFiltersChange,
  onSortingChange,
  data,
  columns,
  rows,
  setSkip,
  skip,
  limit,
  totalLength,
}) => {
  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState("");
  const [columnFilters, setColumnFilters] = useState([]);

  useEffect(() => {
    onFiltersChange(columnFilters, true);
  }, [columnFilters]);

  useEffect(() => {
    onSortingChange(sorting);
  }, [sorting]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sorting,
      globalFilter: filtering,
      columnFilters,
    },
    initialState: {
      pagination: {
        pageSize: rows[1],
      },
    },
    onColumnFiltersChange: setColumnFilters,
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,

    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
  });

  const gotoNext = () => {
    setSkip((prev) => {
      if (prev + limit >= totalLength) return prev;
      return prev + limit;
    });
  };

  const gotoPrev = () => {
    setSkip((prev) => {
      if (prev - limit < 0) return 0;
      return prev - limit;
    });
  };

  const gotoStart = () => {
    setSkip(0);
  };

  const gotoEnd = () => {
    const topOffset = totalLength % limit;
    setSkip(totalLength - (topOffset === 0 ? limit : topOffset));
  };

  const currentPage = Math.floor(skip / limit) + 1;
  const showingFromNumber = (currentPage - 1) * limit + 1;
  const showingToNumber = Math.min(
    (currentPage - 1) * limit + limit,
    totalLength
  );

  return {
    table,
    gotoNext,
    gotoPrev,
    gotoStart,
    gotoEnd,
    currentPage,
    showingFromNumber,
    showingToNumber,
  };
};

export default useServerPaginatedDataTableFilter;
